"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var constants_1 = require("containers/TableMaker/constants");
var Text_1 = __importDefault(require("shared/components/Text"));
var EmailHeadersCell_1 = __importDefault(require("./EmailHeadersCell"));
var EmailHeadersRow_1 = __importDefault(require("./EmailHeadersRow"));
var Header_1 = __importDefault(require("./Header"));
var TableFieldText_1 = __importDefault(require("./TableFieldText"));
var XL = constants_1.CellSize.XL, XS = constants_1.CellSize.XS;
var OutgoingName = function () { return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ py: 5 }, { children: [(0, jsx_runtime_1.jsx)(Header_1.default, __assign({ heading: "From name field", description: "This appears in our outgoing emails to your customers as:" }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone" }, { children: "[Your Name] via Rechargly <notifications@rechargly.com>" })) })), (0, jsx_runtime_1.jsx)(EmailHeadersRow_1.default, { children: (0, jsx_runtime_1.jsx)(EmailHeadersCell_1.default, __assign({ width: XL + XS + 14 }, { children: (0, jsx_runtime_1.jsx)(TableFieldText_1.default, { name: "viaName" }) })) })] }))); };
exports.default = OutgoingName;
